import { buildApiUrl } from "../../../config.js";
import React, { useState } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";

const EditInventoryModal = ({ item, onClose, onUpdate, fetchItems }) => {
  const [formData, setFormData] = useState({
    inventoryId: item?._id || "",
    warehouseName: item?.warehouseName || "",
    itemCategory: item?.itemCategory || "",
    itemCode: item?.itemCode || "",
    itemName: item?.itemName || "",
    openingStock: item?.openingStock || 0,
    inwardStock: item?.inwardStock || 0,
    transferIn: item?.transferIn || 0,
    transferOut: item?.transferOut || 0,
    salesReturn: item?.salesReturn || 0,
    salesOut: item?.salesOut || 0,
    inwardReference: item?.inwardReference || "",
    inwardShipmentMark: item?.inwardShipmentMark || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue =
      name === "openingStock" ||
      name === "inwardStock" ||
      name === "transferIn" ||
      name === "transferOut" ||
      name === "salesReturn" ||
      name === "salesOut"
        ? Number(value)
        : value;

    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        buildApiUrl(`/api/warehouse/inventory/${item._id}`),
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Item updated successfully.");
        fetchItems();
        onClose();
      } else {
        toast.error("Failed to update item.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the item.");
      console.error(error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50 transition-opacity duration-300">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-3xl mx-4 p-4 transform transition-all duration-300 scale-100">
        <div className="flex items-center justify-between border-b border-gray-200 pb-2">
          <div className="flex items-center gap-2">
            <FaEdit className="text-indigo-600" size={16} />
            <h2 className="text-lg font-semibold text-gray-800">
              Edit Inventory Item
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaTimes size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-3 space-y-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="inwardReference"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Batch
              </label>
              <input
                id="inwardReference"
                type="text"
                name="inwardReference"
                value={formData.inwardReference}
                onChange={handleChange}
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              />
            </div>

            <div>
              <label
                htmlFor="inwardShipmentMark"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Shipping Mark
              </label>
              <input
                id="inwardShipmentMark"
                type="text"
                name="inwardShipmentMark"
                value={formData.inwardShipmentMark}
                onChange={handleChange}
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              />
            </div>

            <div>
              <label
                htmlFor="openingStock"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Opening Stock
              </label>
              <input
                id="openingStock"
                type="number"
                name="openingStock"
                value={formData.openingStock}
                onChange={handleChange}
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
              />
            </div>

            <div>
              <label
                htmlFor="warehouseName"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Warehouse Name
              </label>
              <input
                id="warehouseName"
                type="text"
                name="warehouseName"
                value={formData.warehouseName}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="itemCategory"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Item Category
              </label>
              <input
                id="itemCategory"
                type="text"
                name="itemCategory"
                value={formData.itemCategory}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="itemCode"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Item Code
              </label>
              <input
                id="itemCode"
                type="text"
                name="itemCode"
                value={formData.itemCode}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="itemName"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Item Name
              </label>
              <input
                id="itemName"
                type="text"
                name="itemName"
                value={formData.itemName}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="inwardStock"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Inward Stock
              </label>
              <input
                id="inwardStock"
                type="number"
                name="inwardStock"
                value={formData.inwardStock}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="transferIn"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Transfer In
              </label>
              <input
                id="transferIn"
                type="number"
                name="transferIn"
                value={formData.transferIn}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="transferOut"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Transfer Out
              </label>
              <input
                id="transferOut"
                type="number"
                name="transferOut"
                value={formData.transferOut}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="salesReturn"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Sales Return
              </label>
              <input
                id="salesReturn"
                type="number"
                name="salesReturn"
                value={formData.salesReturn}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>

            <div>
              <label
                htmlFor="salesOut"
                className="block text-xs font-medium text-gray-600 mb-1"
              >
                Sales Out
              </label>
              <input
                id="salesOut"
                type="number"
                name="salesOut"
                value={formData.salesOut}
                onChange={handleChange}
                readOnly
                className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed"
              />
            </div>
          </div>

          <div className="flex justify-end items-center pt-3 border-t border-gray-200 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-2 bg-gray-200 text-gray-700 text-xs rounded-md hover:bg-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-3 py-2 bg-indigo-600 text-white text-xs rounded-md hover:bg-indigo-800 transition-colors duration-200 flex items-center gap-1"
            >
              <FaEdit size={12} />
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(EditInventoryModal);
